import * as React from "react";
import { useStaticData } from "context/staticData";
import I18n from "shared/types/I18n";
import { getEnvironment } from "shared/utils/config";
import { Environment } from "shared/utils/enums";
import { AnyObject } from "global";
import { getResolvedString } from "shared/utils";
import { log } from "shared/debug";

export function useCopies(): Copies {
  const { copies } = useStaticData();
  const get = React.useCallback(
    (key: keyof I18n, placeholders?: AnyObject) => {
      if (!copies[key]) {
        log.error("Missing Key ", key, "and value is ", copies[key]);
        if (getEnvironment() === Environment.LOCAL) {
          // alert("Update copies.");
          // throw an error with the name of missing key
          throw Error(`copy for: ${key} not found`);
        }
      }
      if (process.env.REACT_APP_CUSTOM_ENV === Environment.WRITING_TEST_CASES) {
        return key;
      }
      const copy = copies[key] ? copies[key] : key;
      return placeholders ? getResolvedString(copy, placeholders) : copy;
    },
    [copies]
  );

  return React.useMemo(() => {
    return {
      get
    };
  }, [get]);
}

export interface Copies {
  get: (key: keyof I18n, placeholders?: AnyObject) => string;
}
